import { Checkbox } from "@constants/variables";

const castCheckBoxToNumber = (value: boolean): number => {
  return value ? Number(Checkbox.ON) : Number(Checkbox.OFF);
};

export default castCheckBoxToNumber;
